import type { SelfSharedFoldersResponseDatagramBuf } from "~/classes/generated/response"
import type { File } from "~/models/polyschema/File"

import { DatagramBuf } from "~/classes/generated/datagram"
import { RequestDatagramBuf, SelfSharedFoldersRequestDatagramBuf } from "~/classes/generated/request"
import { DatagramBufferBuilder } from "~/utils/flatbuffers/builder"
import { addRequestIdToBuf, parseDatagramError, parseRequestId } from "~/utils/flatbuffers/datagram"
import { parseSelfSharedFolder } from "~/utils/flatbuffers/user"
import { maybe } from "~/utils/helpers"

const console = useLogger("user/info", theme.colors.pink.hex)

export function sendSelfSharedFoldersRequest(request: SelfSharedFoldersRequestDatagram) {
  const { sendWorkerDatagramBuf } = useCache()

  const fbb = new DatagramBufferBuilder(64)
  const requestId = addRequestIdToBuf(fbb, request.requestId)
  SelfSharedFoldersRequestDatagramBuf.startSelfSharedFoldersRequestDatagramBuf(fbb)
  SelfSharedFoldersRequestDatagramBuf.addRequestId(fbb, requestId)
  SelfSharedFoldersRequestDatagramBuf.addOffline(fbb, request.offline)
  const infoRequest = SelfSharedFoldersRequestDatagramBuf.endSelfSharedFoldersRequestDatagramBuf(fbb)

  RequestDatagramBuf.startRequestDatagramBuf(fbb)
  RequestDatagramBuf.addSelfSharedFoldersRequest(fbb, infoRequest)
  const requests = DatagramBuf.createRequestVector(fbb, [RequestDatagramBuf.endRequestDatagramBuf(fbb)])
  DatagramBuf.startDatagramBuf(fbb)
  DatagramBuf.addRequest(fbb, requests)
  fbb.finish(DatagramBuf.endDatagramBuf(fbb))
  sendWorkerDatagramBuf(fbb.asUint8Array())
}

export function handleSelfSharedFoldersResponseDatagramBuf(datagram: SelfSharedFoldersResponseDatagramBuf) {
  const sharedFolders: Record<string, [File, File]> = {}
  for (const i of range(datagram.sharedFoldersLength())) {
    const { sharedFolderId, home, archive } = parseSelfSharedFolder(datagram.sharedFolders(i)!)
    sharedFolders[sharedFolderId] = [home, archive]
  }

  onSelfSharedFoldersResponseDatagram({
    requestId: parseRequestId(datagram.requestId()!),
    offline: datagram.offline(),
    error: maybe(parseDatagramError)(datagram.error()),
    sharedFolders,
  })
}

export function onSelfSharedFoldersResponseDatagram(response: SelfSharedFoldersResponseDatagram) {
  const { emitInterfaceEvent, emitEntityEvent } = useEvents()
  emitInterfaceEvent("selfSharedFoldersResponse", response, response.requestId)

  if (response.error || response.sharedFolders === undefined)
    return console.error("Shared folders info request failed", response)

  for (const roots of Object.values(response.sharedFolders)) {
    const [home, archive] = roots!
    emitEntityEvent("fileProperties", home.id, home, response.offline)
    emitEntityEvent("fileProperties", archive.id, archive, response.offline)
  }
}
